module.exports = __webpack_public_path__ + "static/media/howto_longjob.dd64070e.png";